import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { FormControl, FormGroupDirective, FormBuilder, FormGroup, NgForm, Validators } from '@angular/forms';
import { ExamsService } from '../../../services/exams/exams.service';

@Component({
  selector: 'app-exams-course-add',
  templateUrl: './exams-course-add.component.html',
  styleUrls: ['./exams-course-add.component.css']
})
export class ExamsCourseAddComponent implements OnInit {

  examCourseForm: FormGroup;
  name: string = '';
  shortName: string = '';
  description: string = '';

  isLoadingResults = false;
  isShortNameExist = true;

  constructor(private router: Router,
    private route: ActivatedRoute,
    private formBuilder: FormBuilder,
    private examsService: ExamsService) { }

  ngOnInit() {
    this.examCourseForm = this.formBuilder.group({
      'name': [null, [Validators.required, Validators.minLength(3), Validators.maxLength(120)]],
      'shortName': [null, [Validators.required, Validators.minLength(2), Validators.maxLength(120)]],
      'description': [null, [Validators.required, Validators.minLength(4), Validators.maxLength(280)]]
      //},{ updateOn: 'blur' });
    });
    console.log(this.examCourseForm);
  }

  onFormSubmit(form: NgForm) {
    this.isLoadingResults = true;
    this.examsService.addExamCourse(form)
      .subscribe(res => {
        //let id = res['id'];
        this.isLoadingResults = false;
        //this.router.navigate(['/product-details', id]);
        this.router.navigate(['/exams/examCourseList']);
        //location.href = "/users";
        //this.router.navigateByUrl('users');
        //this.router.navigate([ 'users' ], { relativeTo: this.route })
      }, (err) => {
        console.log(err);
        this.isLoadingResults = false;
      });
  }

}
